import api from './apiClient';

const buildEndpoint = (pathname) => {
  if (!pathname || pathname === '/apply') {
    return '/b2c/apply';
  }

  if (pathname.startsWith('/apply/')) {
    return `/b2c/apply${pathname.slice('/apply'.length)}`;
  }

  return '/b2c/apply';
};

export const fetchApplyContext = async () => {
  const { pathname, search } = window.location;
  const endpoint = buildEndpoint(pathname);
  const params = Object.fromEntries(new URLSearchParams(search));

  const response = await api.get(endpoint, {
    params,
  });

  return response.data;
};

export default {
  fetchApplyContext,
};
